import { Modal } from '@st/theme'
import { match } from '@st/pattern'
import { useProcess, useSelect } from '~/store'
import { SendClientOrganizerDialog } from './send-client-organizer-dialog'
import { STBulkSendEditQuestionnaireDialog } from './st-bulk-send-edit-questionnaire-dialog'
import { STCopyShareableLinkDialog } from './st-copy-shareable-link-dialog'
import { STRequestItemsDialog } from './st-request-items-dialog'
import {
  closeSendClientOrganizerDialog,
  selOpenOrganizerEditor,
  type STSendClientOrganizerMessage
} from './st-send-client-organizer-module'

/** Renders the one organizer-email workflow selected by module state. */
export function STSendClientOrganizerModal() {
  const process = useProcess('stSendClientOrganizer')
  const state = useSelect('stSendClientOrganizer', (state) => state)

  if (state.phase == 'closed') {
    return null
  }

  const props = {
    state: selOpenOrganizerEditor(state),
    send: (message: STSendClientOrganizerMessage) => process.send({ type: 'email', message }),
    onClose: () => process.send(closeSendClientOrganizerDialog())
  }

  return (
    <Modal isOpen={true}>
      {match(state.email.dialog)
        .with('sendEmail', () => <SendClientOrganizerDialog {...props} />)
        .with('shareableLink', () => <STCopyShareableLinkDialog {...props} />)
        .with('requestMissingDocuments', () => <STRequestItemsDialog {...props} />)
        .with('editBulkEmail', () => <STBulkSendEditQuestionnaireDialog {...props} />)
        .exhaustive()}
    </Modal>
  )
}
